export default __webpack_public_path__ + "assets/img/fontawesome-webfont.8b43027f47b20503057dfbbaa9401fef.eot";